import { BefGlobalContext } from "@beflam/bef-core";
import { BefMyIssueList } from "@beflam/bef-issue";
import { useContext } from "react";

function MyIssueList() {

    const globalService = useContext(BefGlobalContext);
    const appId = globalService.session.appId;
    const sessionId = globalService.session.id;
    const userId = globalService.session.userId;
    const host = globalService.config.host;
    return (
        <div style={{ flex: 1, width: '100%', display: 'flex', flexDirection: 'column' }}>
            <BefMyIssueList style={{ flex: 1, height: '88vh' }}
                info={{
                    appId: appId,
                    sessionId: sessionId,
                    host: host,
                    author: userId,
                }}
            />
        </div>);
}

export default MyIssueList;